import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import DataTable from "react-data-table-component";
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaRegEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { deleteannouncement, getannouncementlist } from '../../actions/users';
import { toast } from 'react-toastify';
import { FaEyeSlash } from 'react-icons/fa6';

const AnnouncementList = () => {


    const navigate = useNavigate();


    const [announcementList, setAnnouncementList] = useState([]);
    const [searchText, setSearchText] = useState("");

    function editR(data) {
        if (data != '') {
            navigate({
                pathname: "/announcementedit/" + data._id,
                state: {
                    items: data
                }
            })
        }
    }

    const deleteR = async (data) => {
        try {
            
            let deleted = data?.Deleted == "0" ? "1" : "0"
            let resp = await deleteannouncement(data?._id, deleted);
            console.log("🚀 ~ deleteR ~ resp:", resp)
            
            if (resp.announcementdata?.data.status) {
                toast.success(resp.announcementdata?.data.message, 1000);
            }
            getAnnouncementList();

        } catch (err) {
            console.error("deleteR_err", err)
        }
    }

    const getAnnouncementList = async () => {
        try {
            var resp = await getannouncementlist({searchText});
            
            if (resp?.announcementdata?.length > 0) {
                
                setAnnouncementList(resp?.announcementdata)
            } else {
                setAnnouncementList([])
            }
        } catch (err) {
            console.error("errrrrrr", err)
        }
    }

    useEffect(() => {
        getAnnouncementList();
    }, [searchText]);

    const columns = [

        {

            key: "Description",
            name: "Description",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => (
                <p>{row?.Description}</p>
            ),

        },
        {

            key: "URL",
            name: "URL",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => (
                <p>{row?.Url}</p>
            ),

        },         
        {

            key: "Action",
            name: "Action",
            // className: "tokenQuantity",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => {
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            className="btn btn-primary btn-sm"
                            onClick={() => editR(row)}
                            style={{ marginRight: '5px' }}
                        >
                            <FaRegEdit />
                        </button>
                        <button
                            data-toggle="modal"
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteR(row)}

                            style={{ marginRight: '5px' }}
                        >
                            {
                                row.Deleted == "0"
                                ?
                                <FaEye />
                                :
                                <FaEyeSlash />
                            }
                            
                        </button>
                    </Fragment>
                );
            }

        },
    ];

    return (
        <Layout>
            <div className="announcementlist">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h1 className="pagehead mb-0">Announcement List</h1>
                    <Link to="/announcementadd" className="btn sitebtn py-2 px-3">Add</Link>
                </div>
                <div className="cardbox">
                    <div className="tablebox">
                        <Form.Control type="text" onChange={(e)=>setSearchText(e?.target?.value)} value={searchText} placeholder="Enter url" />
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={announcementList}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default AnnouncementList;